import styled from 'styled-components'
import Button from '../Button/Button'

export const TopLeftControls = styled.div`
  position: absolute;
  top: 1rem;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
`

export const TopControls = styled.div<{ spaceBetween?: boolean }>`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 999;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  left: ${({ spaceBetween }) => (spaceBetween ? '1rem' : 'unset')};
  justify-content: ${({ spaceBetween }) => (spaceBetween ? 'space-between' : 'end')};
`

export const TopRightControls = styled.div`
  position: absolute;
  top: 5rem;
  right: 1rem;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const LeftBottomControls = styled.div<{ $panoActive: boolean; $smallMap: boolean }>`
  position: absolute;
  bottom: ${({ $panoActive, $smallMap }) => ($panoActive && $smallMap ? '1.5rem' : '1rem')};
  z-index: 999;
  left: ${({ $panoActive, $smallMap }) => ($panoActive && $smallMap ? '1.5rem' : '1rem')};
  gap: 0.5rem;
  display: inline-flex;
  align-self: flex-start;
`

export const RightBottomControls = styled.div`
  position: absolute;
  bottom: 1rem;
  z-index: 999;
  right: 1rem;
  gap: 0.5rem;
  display: inline-flex;
  align-self: flex-start;
`

export const MapButton = styled(Button)`
  font-size: 1.125rem;
  line-height: 1.6;
  font-weight: 400;
  border-width: 2px;
  padding: 0.5rem;
`
export const LargeMapButton = styled(Button)`
  background-color: var(--blue) !important;
  svg {
    path,
    rect {
      fill: var(--light) !important;
    }
  }
`
